import request from '@/utils/request'

export function classAdd(data) {
  return request({
    url: 'user',
    method: 'post',
    data
  })
}

export function login(data) {
  return request({
    url: 'auths/login',
    method: 'post',
    data
  })
}
export function verifyCode(code) {
  return request({
    url: 'auths/verifyCode/' + code,
    method: 'post'
  })
}

export function getCaptcha2() {
  return request({
    url: 'auths/captcha2',
    method: 'get'
  })
}

export function verifyCode2(data) {
  return request({
    url: 'auths/verifyCode2',
    method: 'post',
    data
  })
}

// 获取当前用户信息
export function getUserInfo() {
  return request({
    url: '/user/info',
    method: 'get'
  })
}

// 获取用户信息（用于store）
export function getInfo() {
  return request({
    url: '/user/info',
    method: 'get'
  })
}

// 更新用户信息
export function updateUserInfo(data) {
  return request({
    url: '/user/update',
    method: 'post',
    data
  })
}

export function logout() {
  return request({
    url: '/auths/logout',
    method: 'delete'
  })
}

// 获取学生在指定课程中的班级信息
export function getStudentClassesInCourse(courseId) {
  return request({
    url: `/student-bind/course/${courseId}/classes`,
    method: 'get'
  })
}

export function userPaging(params) {
  return request({
    url: 'user/paging',
    method: 'get',
    params
  })
}

export function pageStudentCandidates(params) {
  return request({
    url: 'user/student/page',
    method: 'get',
    params
  })
}
export function userDel(ids) {
  return request({
    url: 'user/' + ids,
    method: 'delete'
  })
}
export function userImport(data) {
  return request({
    url: 'user/import',
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    data
  })
}

export function changePassword(data) {
  return request({
    url: 'user',
    method: 'put',
    data
  })
}

export function verifyCurrentPassword(data) {
  return request({
    url: '/user/verify-password',
    method: 'post',
    data
  })
}

export function userAddClass(params) {
  return request({
    url: 'user/grade/join',
    method: 'put',
    params
  })
}

export function register(data) {
  return request({
    url: 'auths/register',
    method: 'post',
    data
  })
}

export function trackPresence(data) {
  return request({
    url: 'auths/track-presence',
    method: 'post',
    data
  })
}

export function uploadAvatar(data) {
  return request({
    url: 'user/uploadAvatar',
    method: 'put',
    data
  })
}

// 学生退出班级
export function exitUserGrade() {
  return request({
    url: 'grades/user/exit',
    method: 'put'
  })
}

// 更新用户信息
export function updateUser(data) {
  return request({
    url: '/user/update',
    method: 'post',
    data
  })
}

export function updateUserVip(userId, vip) {
  return request({
    url: `/user/${userId}/vip`,
    method: 'put',
    params: { vip }
  })
}

// 更新用户信息填写标记
export function updateUserMark(id, mark) {
  return request({
    url: '/user/update',
    method: 'post',
    data: {
      id,
      mark
    }
  })
}

// 绑定学生信息
export function bindStudent(data) {
  return request({
    url: '/student-bind/bind',
    method: 'post',
    data
  })
}

// 检查学生绑定状态
export function checkStudentBindStatus() {
  return request({
    url: '/student-bind/status',
    method: 'get'
  })
}

// 获取学生绑定信息
export function getStudentBindInfo() {
  return request({
    url: '/student-bind/info',
    method: 'get'
  })
}

// 解绑学生信息
export function unbindStudent() {
  return request({
    url: '/student-bind/unbind',
    method: 'post'
  })
}

// 搜索用户
export function searchUser(username) {
  return request({
    url: '/user/search',
    method: 'get',
    params: { username }
  })
}

// 获取家长绑定的学生列表
export function getParentBindStudents(parentId) {
  return request({
    url: `/connectuser/parent/${parentId}`,
    method: 'get'
  })
}

// 家长绑定学生
export function parentBindStudent(data) {
  return request({
    url: '/connectuser/bind',
    method: 'post',
    data
  })
}

// 绑定用户
export function bindUser(data) {
  return request({
    url: '/connectuser/create',
    method: 'post',
    data
  })
}

// 获取绑定学生列表
export function getBindStudents(parentId) {
  return request({
    url: `/connectuser/parent/${parentId}`,
    method: 'get'
  })
}

// 根据班级ID查询用户名和用户ID
export function getUsersByGradeId(gradeId) {
  return request({
    url: `/grades/show/${gradeId}`,
    method: 'get'
  })
}

// 根据班级ID列表查询班级信息
export function getGradesByIds(gradeIds) {
  return request({
    url: '/grades/batch-query',
    method: 'post',
    data: gradeIds
  })
}

// 发送邮箱绑定验证码（需要登录）
export function sendBindEmailCode(email) {
  return request({
    url: '/user/email/sendCode',
    method: 'post',
    params: { email }
  })
}

// 校验验证码并绑定邮箱（需要登录）
export function bindEmail(email, code) {
  return request({
    url: '/user/email/bind',
    method: 'post',
    params: { email, code }
  })
}

// 发送注册邮箱验证码（无需登录）
export function sendRegisterEmailCode(email) {
  return request({
    url: '/user/email/sendRegisterCode',
    method: 'post',
    params: { email }
  })
}

// 验证注册邮箱验证码（无需登录）
export function verifyRegisterEmailCode(email, code) {
  return request({
    url: '/user/email/verifyRegisterCode',
    method: 'post',
    params: { email, code }
  })
}

// 发送重置密码邮箱验证码（无需登录）
export function sendResetPasswordCode(email) {
  return request({
    url: '/user/email/sendResetPasswordCode',
    method: 'post',
    params: { email }
  })
}

// 通过邮箱验证码重置密码（无需登录）
export function resetPasswordByEmail(email, code, newPassword) {
  return request({
    url: '/user/email/resetPassword',
    method: 'post',
    params: { email, code, newPassword }
  })
}

// 发送注销账户验证码（需要登录）
export function sendDeleteAccountCode() {
  return request({
    url: '/user/delete/sendCode',
    method: 'post'
  })
}

// 注销用户账户（需要登录和验证码）
export function deleteAccount(code) {
  return request({
    url: '/user/delete/account',
    method: 'post',
    params: { code }
  })
}

// 发送注册短信验证码（无需登录）
export function sendRegisterSmsCode(phone) {
  return request({
    url: '/user/sms/sendRegisterCode',
    method: 'post',
    params: { phone }
  })
}

// 验证注册短信验证码（无需登录）
export function verifyRegisterSmsCode(phone, code) {
  return request({
    url: '/user/sms/verifyRegisterCode',
    method: 'post',
    params: { phone, code }
  })
}

// 发送绑定手机号验证码（需要登录）
export function sendBindPhoneCode(phone) {
  return request({
    url: '/user/sms/sendBindCode',
    method: 'post',
    params: { phone }
  })
}

// 校验验证码并绑定手机号（需要登录）
export function bindPhone(phone, code) {
  return request({
    url: '/user/sms/bind',
    method: 'post',
    params: { phone, code }
  })
}
